import { render, staticRenderFns } from "./Icon.vue?vue&type=template&id=7a1fe461&scoped=true&"
import script from "./Icon.vue?vue&type=script&lang=ts&"
export * from "./Icon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1fe461",
  null
  
)

export default component.exports